var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "loginMain",
      attrs: { id: "loginPopup" },
      on: {
        click: function($event) {
          if ($event.target !== $event.currentTarget) {
            return null
          }
          return _vm.removeDialog($event)
        }
      }
    },
    [
      _c("div", { ref: "errorPrompt", staticClass: "errorPrompt" }, [
        _vm._v(_vm._s(_vm.errorPromptContent))
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "frame" },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.mobile,
                expression: "mobile"
              }
            ],
            staticClass: "field",
            attrs: { placeholder: "手机号码" },
            domProps: { value: _vm.mobile },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.mobile = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: false,
                  expression: "false"
                }
              ],
              staticClass: "verifyImg"
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.verifyImg,
                    expression: "verifyImg"
                  }
                ],
                staticClass: "field",
                staticStyle: { width: "calc(100% - 100px)" },
                attrs: { placeholder: "图形验证码" },
                domProps: { value: _vm.verifyImg },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.verifyImg = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("div", { staticStyle: { width: "8px" } }),
              _vm._v(" "),
              _c(
                "div",
                {
                  ref: "verifyImgWrapper",
                  staticStyle: {
                    width: "100px",
                    height: "50px",
                    position: "relative"
                  },
                  on: { click: _vm.changeVerifyImg }
                },
                [
                  _c("img", {
                    staticStyle: {
                      position: "absolute",
                      top: "0",
                      left: "0",
                      width: "100%",
                      height: "100%"
                    },
                    attrs: {
                      src: "https://shop.ziubao.com/user/getShearCaptcha.do"
                    }
                  })
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.verifyCode,
                expression: "verifyCode"
              }
            ],
            staticClass: "field",
            attrs: { placeholder: "验证码" },
            domProps: { value: _vm.verifyCode },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.verifyCode = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "verifyCode" },
            [
              _vm.showFetchVerifyCode
                ? _c(
                    "van-button",
                    {
                      attrs: { size: "small", plain: "" },
                      on: {
                        click: function($event) {
                          return _vm.fetchMobileVerifyCode("zlkc_invoice")
                        }
                      }
                    },
                    [_vm._v("获取验证码")]
                  )
                : _c(
                    "div",
                    { staticClass: "showFetchVerifyCodeCountDownSecond" },
                    [
                      _vm._v(
                        _vm._s(_vm.showFetchVerifyCodeCountDownSecond) +
                          "s后可重新获取验证码"
                      )
                    ]
                  )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "privacyPrompt" }, [
            _vm.ifAgreeContract
              ? _c(
                  "div",
                  {
                    staticClass: "checkBoxActive",
                    on: {
                      click: function($event) {
                        _vm.ifAgreeContract = !_vm.ifAgreeContract
                      }
                    }
                  },
                  [_c("div", { staticClass: "content" })]
                )
              : _c("div", {
                  staticClass: "checkBoxNegative",
                  on: {
                    click: function($event) {
                      _vm.ifAgreeContract = !_vm.ifAgreeContract
                    }
                  }
                }),
            _vm._v(" "),
            _vm._m(0)
          ]),
          _vm._v(" "),
          _c(
            "van-button",
            {
              staticClass: "submit",
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.mobileLogin }
            },
            [_vm._v("登录")]
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "10px" } }),
          _vm._v(" "),
          _c(
            "van-button",
            {
              staticClass: "submit",
              attrs: { type: "warning", size: "small" },
              on: { click: _vm.removeDialog }
            },
            [_vm._v("取消")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "privacyTitle" }, [
      _vm._v("\n                我已阅读并同意自游宝"),
      _c(
        "a",
        {
          staticClass: "contract",
          attrs: {
            href:
              "https://invoice.ziubao.com/main/static/pdf/web/viewer.html?file=https%3a%2f%2fzyb.ziubao.com%2fccbUnionUserService.pdf"
          }
        },
        [_vm._v("《联合会员协议》")]
      ),
      _c(
        "a",
        {
          staticClass: "contract",
          attrs: {
            href:
              "https://invoice.ziubao.com/main/static/pdf/web/viewer.html?file=https%3a%2f%2fzyb.ziubao.com%2fziubao_service.pdf"
          }
        },
        [_vm._v("《用户协议》")]
      ),
      _vm._v("和"),
      _c(
        "a",
        {
          staticClass: "contract",
          attrs: {
            href:
              "https://invoice.ziubao.com/main/static/pdf/web/viewer.html?file=https%3a%2f%2fzyb.ziubao.com%2fziubao_privacy.pdf"
          }
        },
        [_vm._v("《隐私协议》")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }